import { useState } from 'react';

export const usePagination = ({ data, entriesPerPage = 1, singlePage = false }) => {
  const [pageCount, setPageCount] = useState(1);

  const hasMoreDataToLoad = () => data.length > pageCount * entriesPerPage;

  const nextPage = () =>
    hasMoreDataToLoad && setPageCount((prevPageCount) => prevPageCount + 1);

  const prevPage = () =>
    pageCount > 1 && setPageCount((prevPageCount) => prevPageCount - 1);

  const goToCertainPage = (newPageCount) => () => setPageCount(newPageCount);

  const getDataChunk = () => {
    const offset = singlePage ? entriesPerPage * (pageCount - 1) : 0;
    return data.slice(offset, entriesPerPage * pageCount);
  };

  const getPageCount = () => pageCount;

  return {
    data: getDataChunk(),
    nextPage,
    prevPage,
    hasMoreDataToLoad,
    isFirstPage: pageCount === 1,
    pageCount: getPageCount(),
    goToCertainPage,
  };
};
